const smoothScroll = (element, targetScrollTop, duration) => {
    const startScrollTop = element.scrollTop;
    const change = targetScrollTop - startScrollTop;
    const startTime = performance.now();
    const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // Clamp progress between 0 and 1
        // Ease-out quadratic function
        const easedProgress = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
        // eslint-disable-next-line no-param-reassign
        element.scrollTop = startScrollTop + change * easedProgress;
        if (elapsed < duration) {
            requestAnimationFrame(animateScroll);
        }
    };
    requestAnimationFrame(animateScroll);
};

export { smoothScroll as default };
